import EventItem from "./EventItem";

export default EventItem;
